import { render, staticRenderFns } from "./OrdersId.vue?vue&type=template&id=8bff746c&"
import script from "./OrdersId.vue?vue&type=script&lang=js&"
export * from "./OrdersId.vue?vue&type=script&lang=js&"
import style0 from "./OrdersId.vue?vue&type=style&index=0&id=8bff746c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports